(function() {
    'use strict';

    angular.module('swif.patrimoine')
        .config(router)
        .controller('PatrimoineContractsController', PatrimoineContractsController)
        .controller('PatrimoineContractController', PatrimoineContractController)
        .directive('listGroupItemContract', listGroupItemContract)
        .directive('panelContract', panelContract);



    function router($routeProvider) {
        'ngInject';
        $routeProvider.when('/patrimoine/contracts/table_view', {
            templateUrl: 'partials/patrimoine/contracts_table_view.html',
            controller: 'PatrimoineContractsController',
            reloadOnSearch: false,
            resolve: {
                data: ['swifPatrimoineContractService', function(service) {
                    return service.resolveData();
                }]
            }
        });
        $routeProvider.when('/patrimoine/contracts/explorer_view', {
            templateUrl: 'partials/patrimoine/contracts_explorer_view.html',
            controller: 'PatrimoineContractsController',
            reloadOnSearch: false,
            resolve: {
                data: ['swifPatrimoineContractService', function(service) {
                    return service.resolveData();
                }]
            }
        });
    }


    function PatrimoineContractsController($scope, $uibModal, patrimoine, swif, data) {
        'ngInject';
        console.log('init PatrimoineContractsController');
        var service = patrimoine.contract;
        $scope.data = data;
        $scope.cart = swif.cart;

        $scope.callback = service.callback;
        $scope.preModal = service.preModal;
        $scope.preValidate = service.preValidate;
        $scope.preModalTask = service.preModalTask;
        $scope.preValidateTask = service.preValidateTask;
        $scope.callbackTask = service.callbackTask;
        $scope.preModalOccurrence = service.preModalOccurrence;
        $scope.preValidateOccurrence = service.preValidateOccurrence;
        $scope.callbackOccurrence = service.callbackOccurrence;

        $scope.specialFilters = service.getSpecialFilters();

        $scope.loading = service.recurrence.loading;
        $scope.contract_tasks = {
            contentType: 'patrimoine_contract_task'
        };
        $scope.contracts = data.contracts;
        $scope.occurrences = data.occurrences;
        $scope.tasks = data.tasks;

        $scope.closeCost = closeCost;
        $scope.openCost = openCost;
        $scope.getTaskProgressBarType = getTaskProgressBarType;
        $scope.setSpecialFilter = setSpecialFilter;
        refreshSpecialCounts();
        $scope.tab = {
            occurrences: true,
            tasks: false
        };
        $scope.selectTab = selectTab;
        $scope.$watch('contracts.currentItem', watchCurrentItem);
        $scope.$watch('contracts.loading.items', watchLoading, true);
        $scope.$watchCollection('contracts.items', watchItems);


        function closeCost() {
            $scope.modalInstance.close();
        }

        function openCost(item) {
            $scope.contracts.setCurrent(item);
            $scope.modalInstance = $uibModal.open({
                templateUrl: 'partials/patrimoine/contract_cost_modal.html',
                size: 'lg',
                scope: $scope
            });
        }

        function getTaskProgressBarType(task) {
            if (task.state === 'done') {
                return 'success';
            } else if (task.state === 'cancelled') {
                return 'danger';
            } else {
                return 'info';
            }
        }

        /* @param counter: the counter used to recompute the collection filter
         * if counter is activated, add it with an extraFilter,
         * else, remove this extraFilter
         */
        function applySpecialFilter(counter) {
            var newFilter = angular.copy($scope.contracts.currentFilter);
            swif.data.resetExtraFilter(newFilter, 'controlsContracts');
            if (counter.active) {
                _.forEach(counter.extraFilter, function(item) {
                    swif.data.addExtraFilter(newFilter, 'controlsContracts', item);
                });
            }
            $scope.contracts.currentFilter = newFilter;
        }

        /* @param counter: the counter that was clicked
         * @notes: deactivate all other counters,
         * and toogle the clicked one ('coutner' param).
         * It allows to apply ONE counter, or NOT ANY counter.
         */
        function setSpecialFilter(counter) {
            counter.active = !counter.active;
            _.forEach($scope.specialFilters, function(item) {
                if (item.active && item.id !== counter.id) {
                    item.active = false;
                }
            });
            applySpecialFilter(counter);
        }

        /* @param counter: (object) counter to update the length (get count)
         * @notes: re-compute the length of each special counter,
         * taking care of not override their filters each other
         */
        function refreshSpecialCounts() {
            _.forEach($scope.specialFilters, function(counter) {
                var filter = angular.copy($scope.contracts.currentFilter);
                // i want counters keep their own length, with current filters,
                // but without being override by other special filters
                swif.data.resetExtraFilter(filter, 'controlsContracts');
                _.forEach(counter.extraFilter, function(item) {
                    swif.data.addFilter(filter, item);
                });
                swif.data.getContentRange('patrimoine_contract', filter)
                    .then(function(data) {
                        counter.length = data;
                    });
            });
        }

        function onTasksCollection(collection) {
            $scope.tasks = collection;
            swif.message.loading($scope.loading.tasks, 'ok');
        }

        function onTasksCollectionError(err) {
            console.warning(err);
        }

        function onOccurrencesCollection(collection) {
            $scope.occurrences = collection;
            swif.message.loading($scope.loading.tasks, 'ok');
        }

        function watchCurrentItem(newV, oldV) {
            if (!angular.equals(newV, oldV) && newV) {
                swif.message.loading($scope.loading.tasks);
                service.createOccurrencesCollection(newV).then(
                    onOccurrencesCollection, onTasksCollectionError
                );
                service.createTasksCollection(newV).then(
                    onTasksCollection, onTasksCollectionError
                );
            }
        }

        function watchLoading(newV, oldV) {
            if (!angular.equals(newV, oldV) && newV.loading) {
                refreshSpecialCounts();
            }
        }

        function watchItems(newV) {
            if (newV && $scope.contracts.currentItem) {
                if ($scope.tasks) {
                    $scope.tasks.getItems();
                }
                if ($scope.occurrences) {
                    $scope.occurrences.getItems();
                }
            }
        }
        function selectTab(tab) {
            for(let t in $scope.tab) {
                if (t === tab) {
                    $scope.tab[t] = true;
                } else {
                    $scope.tab[t] = false;
                }
            }
        }
    }


    function PatrimoineContractController($scope, $q, swif, patrimoine) {
        'ngInject';
        var service = patrimoine.contract;
        $scope.patrimoine_type = 'patrimoine_site';
        $scope.helpers = {};
        $scope.previousModel = {};
        $scope.helpers.groupByMany2one = groupByMany2one;
        $scope.mergeSitesWithDefault = mergeSitesWithDefault;
        $scope.mergeControlsProperties = mergeControlsProperties;
        $scope.fetchControleData = fetchControleData;
        $scope.getSitesFilters = getSitesFilters;
        /*
         * @param currentValues: (Array) current value of site_controls
         * @param newV: (Array) new site_ids value
         * @param oldV: (Array) old site_ids value
         * @return: (Array) new value of the site_controls linked with site_ids
         * with following format: [{_index: site_id, name: 'bla', ...}]
         */
        $scope.updateSiteControls = service.updateSiteControls;
        $scope.addDefaultControlProperties = addDefaultControlProperties;
        $scope.fetchAvailableProperties = fetchAvailableProperties;
        $scope.onChangeModel = onChangeModel;
        $scope.initialize = initialize;
        $scope.initialize();
        if ($scope.model.site_ids && $scope.model.site_ids.length > 0) {
            $scope.model._siteControls = [];
                $scope.model._siteControls = $scope.updateSiteControls(
                $scope.model._siteControls,
                $scope.model.site_ids,
                [],
                'patrimoine_site'
            );
        }
        // watch over official_control_type to:
        // - update the filter of control_type_id ('official', '=' True / False)
        // - update filter on control_type_id
        $scope.$watch('model.official_control_type', watchControlType);
        $scope.$watchGroup(['model.is_contract', 'model.is_control'], watchGroupIs);
        $scope.$watch('model.control_type_id', watchControlTypeId);
        $scope.$watch('model._siteControls', watchSiteControls, true);
        $scope.$watch('model.site_ids', watchSiteIds);
        $scope.$watch('model.equipment_ids', watchEquipmentIds);
        $scope.$watch('model._propBycCategory', watchPropByCategory);
        $scope.$watch('model.custom_fields', watchCustomFieds);

        function initialize() {
            console.log('init PatrimoineContractController');
            // first, initialize choices for specific view behavior
            $scope._availableProperties = {};
            $scope.choices = {
                type_renewal: [{
                    id: 'auto',
                    name: 'Automatic renewal'
                }, {
                    id: 'manual',
                    name: 'Manual renewal'
                }, {
                    id: 'none',
                    name: 'No renewal'
                }],
                official_control_type: [{
                    id: true,
                    name: 'Official control',
                    icon: '<i class="fa fa-university"></i>'
                }, {
                    id: false,
                    name: 'Other',
                    icon: '<i class="fa fa-ellipsis-h"></i>'
                }]
            };
            // then, set default values (mainly useful for new created models)
            var defaultVals = {
                official_control_type: true,
                deadline_delay: 30
            };
            $scope.selectedControlType = $scope.choices.official_control_type[0];

            _.defaults($scope.model, defaultVals);
            $scope.model.project_type = 'contract';

            // finally, initilize filters for ui-select components
            $scope.filters = {
                control_type: {
                    domain: [
                        ['is_official', '=', $scope.model.official_control_type]
                    ],
                    fields: ['id', 'name', 'description']
                },
                supplier_id: {
                    domain: [
                        ['supplier', '=', true]
                    ]
                },
                service_id: {
                    domain: [
                        ['is_assignable_to_patrimoine_contract', '=', true]
                    ]
                }
            };
            $scope.fetchControleData($scope.model.control_type_id);
            $scope.getSitesFilters();

            // if task already has some controls on database, initialize them
            if ($scope.model.id) {
                var filter = {};
                swif.data.addFilter(filter, 'project_id', '=', $scope.model.id);
                swif.data.get('patrimoine_site_control_tmpl', undefined, filter)
                    .then(function(data) {
                        // set the _index attribute to correctly react on site_ids updates
                        _.forEach(data, function(item) {
                            if (item.site_id) {
                                item._index = item.site_id[0];
                            }
                            if (item.equipment_id) {
                                item._index = item.equipment_id[0];
                            }
                        });
                        $scope.model._siteControls = data;
                        $scope.fetchAvailableProperties();
                    });
            }
        }

        function fetchControleData(controlType) {
            var ret = $q.defer();
            if (controlType) {
                swif.data.get('patrimoine_control_type', controlType[0])
                    .then(function(result) {
                        var deferSites = $q.defer();
                        var deferProp = $q.defer();
                        var defers = [];
                        $scope.model._controlModel = result;
                        // if model has default site categories,
                        // fetch the related sites and add them to site_ids
                        if (result.site_categ_ids) {
                            defers.push(deferSites.promise);
                            var categ_ids = result.site_categ_ids;
                            var filter = {
                                fields: ['name']
                            };
                            swif.data.addFilter(filter, 'type_id', 'in', categ_ids);
                            if ($scope.model.service_id) {
                                swif.data.addFilter(filter,
                                    'service_ids',
                                    '=',
                                    $scope.model.service_id[0]
                                );
                            }

                            swif.data.get('site', undefined, filter)
                                .then(function(data) {
                                    $scope.defaultSites = data;
                                    deferSites.resolve();
                                });
                        }
                        // if model has default properties categories,
                        // fetch related properties and add them to their own control
                        var controls = $scope.model._siteControls;
                        // controlsMap group the controls by their index, for performances
                        var controlsMap = _.groupBy(controls, '_index');
                        if (result.site_property_categ_ids) {
                            defers.push(deferProp.promise);
                            // 1st, fetch the properties matching the model prop_categ_ids
                            var prop_categ_ids = result.site_property_categ_ids;
                            service.fetchPropertiesFromCategories(prop_categ_ids)
                                .then(function(data) {
                                    // then, group each record by site_id
                                    // CAREFUL: directly add the value by assignement,
                                    // meaning that some watchers may be triggered multiple times
                                    var dataMap = $scope.helpers.groupByMany2one(data, 'site_id');
                                    $scope.sitePropertiesHash = dataMap;
                                    // finally, perform a smart merge of the model with the new sites
                                    _.forEach(controlsMap, function(control, key) {
                                        if (_.has(dataMap, key)) {
                                            var idValues = _.pluck(dataMap[key], 'id');
                                            control.site_property_ids = _.union( control.site_property_ids, idValues);
                                        }
                                    });
                                    deferProp.resolve();
                                });
                        }
                        if (_.isEmpty(defers)) {
                            ret.resolve();
                        } else {
                            $q.all(defers).then(function() {
                                ret.resolve();
                            }, function() {
                                ret.reject();
                            });
                        }
                    });
            } else {
                $scope.model._controlModel = {};
                $scope.sitePropertiesHash = {};
                $scope.defaultSites = {};
                ret.resolve();
            }
            return ret.promise;
        }

        function getSitesFilters() {
            service.task.getSitesFilters(
                $scope.filters,
                $scope.model
            );
        }

        /*
        exemple :
            data = [{'key1':value1, 'equipment_id':[13, 'toto'], 'key2':value2} ,
                    {'key3':value3, 'equipment_id':[4, 'titi'], 'key4':value4}]
            res = groupByMany2one(data, 'equipment_id');
            // res => {'13': [{'key1':value1, 'equipment_id':[13, 'toto'], 'key2':value2}],
                        '4': [{'key3':value3, 'equipment_id':[4, 'titi'], 'key4':value4}]}
         */
        function groupByMany2one(data, field) {
            return _.groupBy(data, function(item) {
                return item[field] ? item[field][0] : 0;
            });
        }

        // @param data: (Array of Object) OPTIONAL, sites to add on contract
        // if set, use it to complete the site_ids values, if not set:
        // retrieve the sites from control-model
        // @notes: merge the actual site_ids with 'data'
        function mergeSitesWithDefault(data) {
            data = data || $scope.defaultSites;
            var idValuesInData = _.pluck(data, 'id');
            $scope.model.site_ids = _.union($scope.model.site_ids, idValuesInData);
        }

        function mergeControlsProperties(controls, props) {
            _.forEach(controls, function(control) {
                if (!control.site_property_ids) {
                    control.site_property_ids = [];
                }
                var key = control._index;
                if (key && _.has(props, key)) {
                    var idValues = _.pluck(props[key], 'id');
                    control.site_property_ids = _.union( control.site_property_ids, idValues);
                }
            });
        }

        /*
         * @param categ_ids: (Array of IDS) OPTIONAL, if set:
         * fetch properties matching these categories and use them
         * to populate the control-properties, if not set: use the default
         * values defined on control-model (if defined) 'sitePropertiesHash'
         * called when the _siteControls change,
         * for each control, ensure it has at least all the properties
         * matching the categories from the controlModel
         */
        function addDefaultControlProperties(categ_ids) {
            var controls = $scope.model._siteControls;
            var props;
            if (controls && categ_ids) {
                // fetch related properties, group them by site
                // and merge control-properties with them
                service.fetchPropertiesFromCategories(categ_ids)
                    .then(function(data) {
                        if (data.length) {
                            if (data[0].site_id) {
                                props = $scope.helpers.groupByMany2one(data, 'site_id');
                            } else {
                                props = $scope.helpers.groupByMany2one(data, 'equipment_id');
                            }
                        }
                        $scope.mergeControlsProperties(controls, props);
                    });
            } else if (controls && $scope.sitePropertiesHash) {
                $scope.mergeControlsProperties(controls, $scope.sitePropertiesHash);
            }
        }

        function fetchAvailableProperties() {
            var ids = _.pluck($scope.model._siteControls, '_index');

            if (!_.isEmpty(ids)) {
                var filter = {};
                var field = 'site_id';
                if ($scope.patrimoine_type === 'patrimoine_equipment') {
                    field = 'equipment_id';
                }
                swif.data.addFilter(filter, field, 'in', ids);
                swif.data.get('patrimoine_property', undefined, filter)
                    .then(function(data) {
                        var props = $scope.helpers.groupByMany2one(data, field);
                        _.forEach(props, function(val, key) {
                            $scope._availableProperties[key] = val;
                        });
                    });
            }
        }

        function onChangeModel(template) {
            var exclude_properties = ['id', '$$hashKey', '_type'];
            _.forOwn(template, function (value, key) {
                if (!_.contains(exclude_properties, key)){
                    if (_.isEmpty($scope.model[key]) || $scope.model[key] == '' || $scope.previousModel[key] == $scope.model[key]) {
                        $scope.model[key] = $scope.previousModel[key] = value;
                    }
                }
            });
        }

        function watchControlType(newV, oldV) {
            if (!angular.equals(newV, oldV)) {
                newV = Boolean(newV);
                var newDomain = [
                    ['is_official', '=', newV]
                ];
                $scope.filters.control_type = {
                    domain: newDomain
                };

                $scope.selectedControlType = _.find(
                    $scope.choices.official_control_type,
                    function(item) {
                        return item.id === newV;
                    }
                );
            }
        }

        function watchGroupIs(newVs) {
            if (newVs[0] === false && newVs[1] === false) {
                //switch the other to true
                $scope.model.is_control = true;
            }
        }

        function watchControlTypeId(newV, oldV) {
            // first, retrieve data to display the description of the control
            if (newV !== oldV) {
                $scope.fetchControleData(newV).then(function() {
                    $scope.mergeSitesWithDefault();
                    $scope.addDefaultControlProperties();
                });
            }
        }

        function watchSiteControls(newV, oldV) {
            // only recompute data when _index changes, not when deeper data change
            if (!angular.equals(_.pluck(newV || {}, '_index'), _.pluck(oldV || {}, '_index'))) {
                $scope.fetchAvailableProperties();
                $scope.addDefaultControlProperties();
            }
        }

        function watchSiteIds(newV, oldV) {
            if (newV) {
                if (newV.length > 0) {
                    $scope.patrimoine_type = 'patrimoine_site';
                    $scope.model.equipment_ids = [];
                }
            }
            if (!angular.equals(newV, oldV)) {
                $scope.getSitesFilters();
                $scope.model._siteControls = $scope.updateSiteControls(
                    $scope.model._siteControls,
                    newV,
                    oldV,
                    'patrimoine_site'
                );
            }
        }

        function watchEquipmentIds(newV, oldV) {
            if (newV) {
                if (newV.length > 0) {
                    $scope.patrimoine_type = 'patrimoine_equipment';
                    $scope.model.site_ids = [];
                }
            }
            if (!angular.equals(newV, oldV)) {
                $scope.getSitesFilters();
                $scope.model._siteControls = $scope.updateSiteControls(
                    $scope.model._siteControls,
                    newV,
                    oldV,
                    'patrimoine_equipment'
                );
            }
        }

        function watchPropByCategory(newV, oldV) {
            if (!angular.equals(newV, oldV) && newV) {
                $scope.fetchAvailableProperties();
                $scope.addDefaultControlProperties([newV[0]]);
            }
        }

        function watchCustomFieds (newV) {
            if (newV) {
                let filter = {};
                filter.fields = ['id', 'name'];
                swif.data.setLimit(filter, 1);
                swif.data.addExtraFilter(filter, 'service', 'name', '=', newV);
                swif.data.searchRead('department', filter).then(function(data) {
                    if (data.records && data.records.length > 0) { 
                        const service = data.records[0];
                        $scope.$parent.$parent.model.service_id = [service.id, service.name];
                    }
                });
            }
        }
    }

    function listGroupItemContract() {
        return {
            restrict: 'A',
            replace: true,
            scope: {
                listGroupItemContract: '='
            },
            templateUrl: 'partials/patrimoine/list-group-item-contract.html'
        };
    }

    function panelContract() {
        return {
            restrict: 'A',
            replace: true,
            transclude: true,
            require: 'ngModel',
            scope: {},
            link: function(scope, element, attr, ngModel) {
                ngModel.$render = function() {
                    scope.item = ngModel.$viewValue;
                };
            },
            templateUrl: 'partials/patrimoine/panel-contract.html'
        };
    }

})();
